/**
 * Vego Garden - Shipment Tracking Module
 * Production-ready implementation
 */
document.addEventListener("DOMContentLoaded", () => {
  const DOM = {
    root: document.getElementById("app-root"),
    orderItemsSection: document.getElementById("vt-order-items-section"),
    orderItemsList: document.getElementById("vt-order-items-list"),
    saleBanner: document.getElementById("vt-tracking-sale-banner")
  };

  const API_CONFIG = {
    url: "https://app.vegogarden.com/customer-tracking-page",
    token: "q0ak7zo73si87nxkixr4jcbe1dvq4i1x"
  };

  const urlParams = new URLSearchParams(window.location.search);
  const fRef = urlParams.get("f_ref");

  const Formatters = {
    date: new Intl.DateTimeFormat('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }),
    time: new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }),
    money: (amount) => {
      const value = parseFloat(amount);
      return Number.isNaN(value) ? amount : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
    }
  };

  const escapeHtml = (unsafe) => {
    if (!unsafe) return '';
    return String(unsafe)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  };

  const ICONS = {
    tracking: `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.3641 5C30.0874 5 30.7811 5.28734 31.2926 5.79881C31.8041 6.31028 32.0914 7.00399 32.0914 7.72732V16.1329C30.5821 14.8114 28.6428 14.0855 26.6368 14.0911C22.1294 14.0911 18.4548 17.662 18.4548 22.0939L18.4594 22.3467C18.5475 24.6403 19.6348 27.0586 21.5503 29.545L5.72732 29.5459C5.00399 29.5459 4.31028 29.2585 3.79881 28.7471C3.28734 28.2356 3 27.5419 3 26.8186V7.72732C3 7.00399 3.28734 6.31028 3.79881 5.79881C4.31028 5.28734 5.00399 5 5.72732 5H29.3641ZM15.7275 16.8184H7.54553V19.5457H15.7275V16.8184ZM23.0003 11.3637H7.54553V14.0911H23.0003V11.3637Z" fill="#3A5B39"/><path d="M26.636 15.9092C30.1506 15.9092 32.9997 18.6783 32.9997 22.0938L32.9952 22.312C32.917 24.3557 31.7542 26.6539 29.846 28.9849C29.1481 29.8336 28.3988 30.6388 27.6023 31.3958L27.2178 31.7558L26.8669 32.0695C26.7641 32.1604 26.6851 32.2267 26.636 32.2676L26.405 32.0695L26.0541 31.7558C25.1134 30.8957 24.2351 29.9697 23.4259 28.9849C21.5168 26.6539 20.3549 24.3557 20.2768 22.312L20.2722 22.0938C20.2722 18.6783 23.1214 15.9092 26.636 15.9092ZM27.0151 28.093C27.2642 27.8176 27.506 27.5385 27.736 27.2566C29.3006 25.3457 30.1451 23.6475 30.2588 22.3775L30.2706 22.2066L30.2724 22.0938C30.2724 20.2029 28.6615 18.6365 26.636 18.6365C24.6741 18.6365 23.1004 20.1056 23.0041 21.9175L22.9995 22.0938L23.0014 22.2066C23.0514 23.4929 23.8996 25.2584 25.5359 27.2566C25.7669 27.5385 26.0078 27.8176 26.2569 28.093L26.636 28.5039L27.0151 28.093Z" fill="#3A5B39"/><path d="M24.8184 22.2743C24.8183 22.5131 24.8653 22.7496 24.9567 22.9702C25.048 23.1908 25.182 23.3913 25.3508 23.5602C25.5196 23.729 25.7201 23.863 25.9407 23.9544C26.1613 24.0458 26.3978 24.0928 26.6366 24.0928C26.8754 24.0928 27.1118 24.0458 27.3324 23.9544C27.553 23.863 27.7535 23.729 27.9223 23.5602C28.0912 23.3913 28.2251 23.1908 28.3165 22.9702C28.4078 22.7496 28.4548 22.5131 28.4548 22.2743C28.4548 22.0355 28.4078 21.799 28.3165 21.5784C28.2251 21.3578 28.0912 21.1573 27.9223 20.9885C27.7535 20.8196 27.553 20.6856 27.3324 20.5942C27.1118 20.5029 26.8754 20.4558 26.6366 20.4558C26.3978 20.4558 26.1613 20.5029 25.9407 20.5942C25.7201 20.6856 25.5196 20.8196 25.3508 20.9885C25.182 21.1573 25.048 21.3578 24.9567 21.5784C24.8653 21.799 24.8183 22.0355 24.8184 22.2743Z" fill="#3A5B39"/></svg>`
  };

  const Templates = {
    mainSkeleton: () => `
      <h1 class="vt-main-title">Shipment Info</h1>
      <div class="vt-wrapper vt-skeleton-wrapper" aria-busy="true">
        <div class="vt-card vt-skeleton-card">
          <div class="vt-card-inner">
            <div class="vt-skeleton-line vt-skeleton-line--lg"></div>
            <div class="vt-skeleton-line vt-skeleton-line--w80"></div>
            <div class="vt-skeleton-line vt-skeleton-line--w40"></div>
            <div class="vt-skeleton-line vt-skeleton-line--w80"></div>
            <div class="vt-skeleton-btn"></div>
          </div>
        </div>
      </div>
    `,
    orderItemSkeleton: () => Array.from({ length: 2 }).map((_, idx) => `
      <div class="vt-order-item-block vt-skeleton-order-item" aria-busy="true">
        <div class="vt-order-item-badge">Item ${idx + 1}/—</div>
        <div class="vt-order-item-card">
          <div class="vt-order-item-card__image-wrap">
            <div class="vt-skeleton-img"></div>
          </div>
          <div class="vt-order-item-card__details">
            <div class="vt-skeleton-line vt-skeleton-line--w80"></div>
            <div class="vt-skeleton-line vt-skeleton-line--w40"></div>
            <div class="vt-skeleton-line vt-skeleton-line--w30"></div>
          </div>
        </div>
        <div class="vt-order-item-recommend" data-recommend-container>
          ${Templates.recommendSkeleton()}
        </div>
      </div>
    `).join(""),
    recommendSkeleton: () => `
      <div class="vt-frequently-skeleton">
        <div class="vt-frequently-skeleton__heading"></div>
        <div class="vt-frequently-skeleton__row">
          ${Array.from({ length: 4 }).map(() => `
            <div class="vt-frequently-skeleton__card">
              <div class="vt-frequently-skeleton__img"></div>
              <div class="vt-frequently-skeleton__lines">
                <div class="vt-frequently-skeleton__line vt-frequently-skeleton__line--w1"></div>
                <div class="vt-frequently-skeleton__line vt-frequently-skeleton__line--w2"></div>
                <div class="vt-frequently-skeleton__btn"></div>
              </div>
            </div>
          `).join("")}
        </div>
      </div>
    `,
    historyList: (history) => history.map((item, index) => `
      <div class="vt-history-item ${index == 0 ? 'current': 'completed'}">
        <div class="vt-history-content">
          <div class="vt-history-date">${Formatters.date.format(new Date(item.timestamp_utc))}</div>
          <p class="vt-history-desc">
            ${Formatters.time.format(new Date(item.timestamp_utc))} 
            ${item.city ? `| ${escapeHtml(item.city)}, ${escapeHtml(item.state)}` : ''} 
            <span class="vt-history-msg">${escapeHtml(item.message)}</span>
          </p>
        </div>
      </div>
    `).join(''),
    message: (text, type) => `<div class="vt-msg ${type}">${escapeHtml(text)}</div>`
  };

  const getLocalePrefix = () => {
    const match = window.location.pathname.match(/^\/(en-[a-z]{2})(?=\/)/);
    return match ? `/${match[1]}` : '';
  };

  const init = async () => {
    if (!fRef) {
      showError("Please access this page using the email related to your shipping.");
      return;
    }

    renderInitialSkeleton();
    loadCollectionBanner();

    try {
      const response = await fetch(`${API_CONFIG.url}/info?accessToken=${API_CONFIG.token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fulfillmentRef: fRef })
      });
      const res = await response.json();

      if (res.code === 200 && res.data) {
        renderApp(res.data);
        renderOrderItems(res.data);
      } else {
        showError(res.message || "Tracking information not found.");
      }
    } catch (error) {
      console.error("Fetch Error:", error);
      showError("Network error. Please try again later.");
    }
  };

  const loadCollectionBanner = async () => {
    if (!DOM.saleBanner) return;

    const pageHandle = DOM.saleBanner.dataset.pageHandle || 'on-sale';
    const locale = getLocalePrefix();

    try {
      const pageRes = await fetch(`${locale}/collections/advanced-beds`);
      if (!pageRes.ok) throw new Error('Banner page fetch failed');

      const pageHtml = await pageRes.text();
      const pageDoc = new DOMParser().parseFromString(pageHtml, 'text/html');
      const bannerNode = pageDoc.querySelector('[data-section-type="collection-hero-banner-section"]');

      if (!bannerNode) {
        DOM.saleBanner.remove();
        return;
      }

      const shopifySection = bannerNode.closest('[id^="shopify-section-"]');
      if (shopifySection && shopifySection.innerHTML.trim()) {
        DOM.saleBanner.innerHTML = shopifySection.innerHTML;
        DOM.saleBanner.removeAttribute('aria-busy');
        return;
      }

      const wrapperId = shopifySection?.id || '';
      const instanceId = wrapperId.replace('shopify-section-', '');
      if (instanceId) {
        const sectionRes = await fetch(`${locale}/pages/${pageHandle}?section_id=${instanceId}`);
        if (sectionRes.ok) {
          const sectionHtml = await sectionRes.text();
          const sectionDoc = new DOMParser().parseFromString(sectionHtml, 'text/html');
          const sectionRoot = sectionDoc.querySelector(`[id="shopify-section-${instanceId}"]`);
          if (sectionRoot && sectionRoot.innerHTML.trim()) {
            DOM.saleBanner.innerHTML = sectionRoot.innerHTML;
            DOM.saleBanner.removeAttribute('aria-busy');
            return;
          }
        }
      }

      DOM.saleBanner.remove();
    } catch (error) {
      console.warn('Failed to load collection banner:', error);
      DOM.saleBanner.remove();
    }
  };

  const renderInitialSkeleton = () => {
    if (DOM.root) DOM.root.innerHTML = Templates.mainSkeleton();
    if (DOM.orderItemsSection && DOM.orderItemsList) {
      DOM.orderItemsSection.style.display = '';
      DOM.orderItemsSection.setAttribute('aria-hidden', 'false');
      DOM.orderItemsList.innerHTML = Templates.orderItemSkeleton();
    }
  };

  const renderApp = (data) => {
    if (!DOM.root) return;

    const trackingObj = data.tracking || data || {};
    const history = trackingObj.history || data.history || [];
    const latest = history[0] || {};
    const trackingNumber = trackingObj.tracking_number || data.tracking_number || 'N/A';
    const trackingUrl = trackingObj.carrier_tracking_url || data.carrier_tracking_url || '#';

    const latestDateHtml = latest.timestamp_utc ? `<div class="vt-date">${Formatters.date.format(new Date(latest.timestamp_utc))}</div>` : '';
    const latestDetailsHtml = latest.timestamp_utc ? `
      <div style="margin: 20px 0;">
        <div class="vt-history-date">${Formatters.date.format(new Date(latest.timestamp_utc))}</div>
        <p class="vt-history-desc">
          ${Formatters.time.format(new Date(latest.timestamp_utc))} 
          ${latest.city ? `| ${escapeHtml(latest.city)}, ${escapeHtml(latest.state)}` : ''} 
          <span class="vt-history-msg">${escapeHtml(latest.message)}</span>
        </p>
      </div>
    ` : '';

    const trackingHtml = `
      <div class="vt-card">
        <div class="vt-card-inner vt-card-inner--shipment">
          ${latestDateHtml}
          <h2 class="vt-title-lg">${escapeHtml(latest.message) || 'Unknown Status'}</h2>
          <hr class="vt-divider" />
          <div class="vt-title-sm">Latest Update</div>
          <div><button id="btn-show-history" class="vt-link">Show Full History</button></div>
          ${latestDetailsHtml}
          <hr class="vt-divider" />
          <div class="vt-track-row">
            ${ICONS.tracking}
            <div>
              <div class="vt-track-label">Tracking Number:</div>
              <a href="${trackingUrl}" target="_blank" class="vt-track-link">${trackingNumber}</a>
            </div>
          </div>
        </div>
      </div>
    `;

    const referralHtml = `
      <div class="vt-card">
        <div class="vt-card-inner">
          <div class="vt-date" style="margin-bottom:4px;">Refer a Friend</div>
          <div class="vt-title-md">GIVE $20, GET $20</div>
          <div class="vt-desc">Give Your Friends $20 Off On Their First Order Of $299+ And Get $20 (In Points) For Each Successful Referral.</div>
          <div style="flex:1;"></div>
          <div style="margin-top:20px;">
            <input type="email" id="referral-email" class="vt-input" placeholder="Friend's email address">
            <div id="referral-msg" class="vt-msg-container"></div>
            <button id="btn-submit-referral" class="vt-btn vego-featuredProducts-btn">Next</button>
          </div>
        </div>
      </div>
    `;

    let surveyHtml = '';
    if (!data.survey_flag && data.survey && data.survey.options) {
      const optionsHtml = data.survey.options.map(opt => `
        <label class="vt-sur-row" for="survey-opt-${opt.id}">
          <input type="checkbox" name="survey_option" id="survey-opt-${opt.id}" value="${opt.id}" data-custom="${opt.custom ? 'true' : 'false'}" class="vt-sur-checkbox">
          <span class="vt-sur-label">${escapeHtml(opt.text)}</span>
        </label>
      `).join('');

      surveyHtml = `
        <div class="vt-card" id="survey-card-wrapper">
          <div class="vt-card-inner">
            <div class="vt-sur-title">Where did you last hear about Vego garden?</div>
            <div id="survey-options-container">${optionsHtml}</div>
            <input type="text" id="survey-custom-input" class="vt-input" placeholder="Please specify" style="display:none; margin-top: 16px;">
            <div id="survey-msg" class="vt-msg-container"></div>
            <div style="flex:1;"></div>
            <button id="btn-submit-survey" class="vt-btn vego-featuredProducts-btn">Submit</button>
          </div>
        </div>
      `;
    }

    let subscribeHtml = '';
    if (!data.email_subscribe_flag) {
      subscribeHtml = `
        <div class="vt-card vt-card--img">
          <div class="vt-card-inner">
            <div class="vt-title-md" style="margin-bottom:10px;">Get A $10 OFF + Free Shipping*</div>
            <div class="vt-desc" style="font-size:12px; line-height:18px;">Be the first to know about our discounts, and get $10 off your next order of $99 + free shipping.</div>
            <button id="btn-trigger-attentive" class="vt-btn vt-btn--green vego-featuredProducts-btn js-sign-up-open">Get Your Coupon</button>
          </div>
        </div>
      `;
    }

    const modalHtml = `
      <div id="vego-history-modal" class="vt-modal-overlay">
        <div class="vt-modal">
          <button id="btn-close-modal" class="vt-modal-close" aria-label="Close">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
          ${latestDateHtml}
          <h2 class="vt-title-lg">${escapeHtml(latest.message) || 'Unknown Status'}</h2>
          <hr class="vt-divider" />
          <div class="vt-title-sm" style="margin-top:0;">Latest Update</div>
          <div class="vt-modal-list">
            ${Templates.historyList(history)}
          </div>
          <hr class="vt-divider" />
          <div class="vt-track-row">
            ${ICONS.tracking}
            <div>
              <div class="vt-track-label">Tracking Number:</div>
              <a href="${trackingUrl}" target="_blank" class="vt-track-link">${trackingNumber}</a>
            </div>
          </div>
        </div>
      </div>
    `;

    DOM.root.innerHTML = `
      <h1 class="vt-main-title">Shipment Info</h1>
      <div class="vt-wrapper">
        ${trackingHtml}
        ${referralHtml}
        ${surveyHtml}
        ${subscribeHtml}
      </div>
      ${modalHtml}
    `;

    bindDelegatedEvents(data);
  };

  const bindDelegatedEvents = (data) => {
    if (!DOM.root) return;

    DOM.root.addEventListener('change', (e) => {
      if (e.target.name === 'survey_option') {
        const customInput = document.getElementById('survey-custom-input');
        if (customInput && e.target.dataset.custom === 'true') {
          customInput.style.display = e.target.checked ? 'block' : 'none';
        }
      }
    });

    DOM.root.addEventListener('click', async (e) => {
      const target = e.target;

      if (target.closest('#btn-show-history')) {
        document.getElementById('vego-history-modal').style.display = 'flex';
        document.body.style.overflow = 'hidden'; 
      }

      if (target.closest('#btn-close-modal') || target.id === 'vego-history-modal') {
        document.getElementById('vego-history-modal').style.display = 'none';
        document.body.style.overflow = '';
      }

      if (target.closest('#btn-submit-referral')) {
        const emailInput = document.getElementById('referral-email');
        const msgContainer = document.getElementById('referral-msg');
        const btn = document.getElementById('btn-submit-referral');
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(emailInput.value.trim())) {
          msgContainer.innerHTML = Templates.message('Please input a valid email address.', 'error'); 
          return;
        }

        btn.innerText = 'Sending...'; 
        btn.disabled = true;

        try {
          const res = await fetch(`${API_CONFIG.url}/send-referral?accessToken=${API_CONFIG.token}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ customerId: data.customer_id, referralEmail: emailInput.value.trim() })
          });
          const result = await res.json();
          if (result.code === 200) {
            msgContainer.innerHTML = Templates.message('Referral email has been sent!', 'success');
            emailInput.value = '';
          } else {
            msgContainer.innerHTML = Templates.message(result.message || 'Submission failed.', 'error');
          }
        } catch (err) {
          msgContainer.innerHTML = Templates.message('Network error.', 'error');
        } finally {
          btn.innerText = 'Next'; btn.disabled = false;
        }
      }

      if (target.closest('#btn-submit-survey')) {
        const msgContainer = document.getElementById('survey-msg');
        const customInput = document.getElementById('survey-custom-input');
        const btn = document.getElementById('btn-submit-survey');
        const checked = Array.from(document.querySelectorAll('input[name="survey_option"]:checked'));
        
        if (checked.length === 0) {
          msgContainer.innerHTML = Templates.message('Please select at least one choice.', 'error'); 
          return;
        }
        
        let hasCustom = checked.find(el => el.dataset.custom === 'true');
        if (hasCustom && !customInput.value.trim()) {
          msgContainer.innerHTML = Templates.message('Please specify other channel.', 'error'); 
          return;
        }

        const surveyResult = {};
        checked.forEach(el => {
          surveyResult[el.value] = el.dataset.custom === 'true' ? customInput.value.trim() : true;
        });

        btn.innerText = 'Submitting...'; btn.disabled = true;

        try {
          const res = await fetch(`${API_CONFIG.url}/send-hear-from?accessToken=${API_CONFIG.token}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ customer_token: data.customer_token, survey_result: surveyResult })
          });
          const result = await res.json();
          if (result.code === 200) {
            msgContainer.innerHTML = Templates.message('Thanks for your feedback!', 'success');
            setTimeout(() => {
              const wrapper = document.getElementById('survey-card-wrapper');
              if(wrapper) wrapper.style.display = 'none';
            }, 2000);
          } else {
            msgContainer.innerHTML = Templates.message(result.message || 'Submission failed.', 'error');
          }
        } catch (err) {
          msgContainer.innerHTML = Templates.message('Network error.', 'error');
        } finally {
          btn.innerText = 'Submit'; btn.disabled = false;
        }
      }

      if (target.closest('#btn-trigger-attentive')) {
        if (window.__attentive) {
          const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
          window.__attentive.trigger(null, null, null, isMobile ? 273905 : 273906);
        }
      }
    });
  };

  const fetchTrackingRecommendations = async (productId) => {
    const baseUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.product_recommendations_url) || '/recommendations/products';
    const url = `${baseUrl}?section_id=tracking-order-recommend&product_id=${productId}&limit=4&intent=related`;
    try {
      const res = await fetch(url);
      if (!res.ok) return null;
      return res.text();
    } catch (error) {
      console.warn('Failed to load tracking recommendations:', productId, error);
      return null;
    }
  };

  const initRecommendCards = (container) => {
    if (!container) return;
    if (typeof window.VegoRecommendUtils?.initRecommendContainer === 'function') {
      window.VegoRecommendUtils.initRecommendContainer(container);
      return;
    }
    container.querySelectorAll('script:not([data-revived])').forEach((oldScript) => {
      const newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach((attr) => newScript.setAttribute(attr.name, attr.value));
      if (oldScript.innerHTML) newScript.appendChild(document.createTextNode(oldScript.innerHTML));
      newScript.setAttribute('data-revived', 'true');
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
    setTimeout(() => {
      try {
        if (window.$ && typeof window.$.fn.vselect === 'function') {
          window.$(container).find('select.grid-product-variant-input:enabled').vselect();
        }
        if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
          window.yotpoWidgetsContainer.initWidgets();
        }
      } catch (e) {}
    }, 100);
  };

  const loadOrderItemRecommendations = async (block, lineItem) => {
    const recommendContainer = block.querySelector('[data-recommend-container]');
    if (recommendContainer && !recommendContainer.dataset.loading) {
      recommendContainer.dataset.loading = 'true';
      recommendContainer.style.display = '';
      recommendContainer.innerHTML = Templates.recommendSkeleton();
    }

    const html = await fetchTrackingRecommendations(lineItem.product_id);
    if (!recommendContainer) return;

    if (!html || !block) {
      recommendContainer.innerHTML = '';
      recommendContainer.style.display = 'none';
      delete recommendContainer.dataset.loading;
      return;
    }

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const metaEl = doc.querySelector('.vt-product-meta');
    
    if (metaEl) {
      try {
        const meta = JSON.parse(metaEl.textContent);
        let imageUrl = meta.featured_image;
        const variantMatch = (meta.variants || []).find((variant) => String(variant.id) === String(lineItem.variant_id));
        if (variantMatch && variantMatch.image) imageUrl = variantMatch.image;

        const img = block.querySelector('.vt-order-item-card__image');
        if (img && imageUrl) {
          img.src = imageUrl;
          img.alt = lineItem.title || '';
        }
      } catch (e) {}
    }

    const frequentlySection = doc.querySelector('.vt-frequently-bought');
    if (!frequentlySection) {
      recommendContainer.innerHTML = '';
      recommendContainer.style.display = 'none';
      delete recommendContainer.dataset.loading;
      return;
    }

    recommendContainer.style.display = '';
    recommendContainer.innerHTML = '';
    recommendContainer.appendChild(frequentlySection);
    delete recommendContainer.dataset.loading;
    initRecommendCards(recommendContainer);
  };

  const renderOrderItems = async (data) => {
    const lineItems = data.line_items;
    if (!lineItems || !lineItems.length || !DOM.orderItemsSection || !DOM.orderItemsList) return;

    DOM.orderItemsSection.style.display = '';
    DOM.orderItemsList.innerHTML = '';

    const total = lineItems.length;
    lineItems.forEach((item, index) => {
      const block = document.createElement('div');
      block.className = 'vt-order-item-block';
      block.dataset.productId = item.product_id;
      block.dataset.variantId = item.variant_id;

      const variantHtml = item.variant_title && item.variant_title !== 'Default Title'
        ? `<div class="vt-order-item-card__variant">${escapeHtml(item.variant_title)}</div>` : '';

      block.innerHTML = `
        <div class="vt-order-item-badge">Item ${index + 1}/${total}</div>
        <div class="vt-order-item-card">
          <div class="vt-order-item-card__image-wrap">
            <img class="vt-order-item-card__image" src="" alt="${escapeHtml(item.title || '')}" loading="lazy">
          </div>
          <div class="vt-order-item-card__details">
            <h3 class="vt-order-item-card__title">${escapeHtml(item.title)}</h3>
            <div class="vt-order-item-card__price">${Formatters.money(item.price)}</div>
            <div class="vt-order-item-card__qty">Qty: ${item.quantity}</div>
            ${variantHtml}
          </div>
        </div>
        <div class="vt-order-item-recommend" data-recommend-container></div>
      `;
      DOM.orderItemsList.appendChild(block);
    });

    await Promise.all(
      lineItems.map((item, index) => loadOrderItemRecommendations(DOM.orderItemsList.children[index], item))
    );
  };

  const showError = (msg) => {
    if(DOM.root) DOM.root.innerHTML = `<h1 class="vt-main-title">Shipment Info</h1><div class="vego-tracking-error-msg">${escapeHtml(msg)}</div>`;
    if (DOM.orderItemsSection) DOM.orderItemsSection.style.display = 'none';
  };

  // Bootstrap Application
  init();
});
